import axios from 'axios';
import { API_BASE_URL } from './constants/api.constants';

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
});

// Request Interceptor to add access token
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers['x-access-token'] = token;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor WITHOUT refresh token logic
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        // Just return the error if 401 or 403 (no retry or refresh)
        return Promise.reject(error);
    }
);

export default axiosInstance